import { gql } from '@apollo/client';

export const UPDATE_OIADA_MEMBERS = gql`
  mutation UpdateOiadaMembers ($file: Upload!) {
    updateOiadaMembers(file: $file) {
      errors { path, message }
    }
  }
`;
